import config from '../../util/config';

export const createVgsShowInstance = (): VGSShowInstance =>
  window.VGSShow.create(config.vgs.vault, () => null)
    .setEnvironment(config.vgs.environment)
    .setCname(config.vgs.cname);
